import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    branches: [],
    branchTotal: 0,
    currentPage: 1,
    perPage: 5,
    searchQuery: "",
    filterValue: "",
    tableLoading: false,
    currentViewedBranch: {},
    branchTypes: [],
  },
  actions,
  getters,
  mutations,
};
